const BrandItemSkeleton = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <div className="min-w-14 w-14 h-14 rounded-full object-fill bg-gray-200 animate-pulse" />
      <div className="text-white text-sm bg-gray-200 w-14 h-3 rounded-lg animate-pulse" />
    </div>
  );
};

export default BrandItemSkeleton;
